/* c8 ignore start */
export function isLike(value, ...and) {
    if (!and.length)
        return !!value;
    return !!value && and.every((value) => !!value);
}
export function ok(value, message, ...conditions) {
    if (conditions.length ? !conditions.every((value) => value) : !value) {
        throw new Error(message ?? "Expected value");
    }
}
//# sourceMappingURL=is.js.map